import { LoadingButton } from "@mui/lab";
import {
  SignInFormActionsProps,
  SignUpFormActionsProps,
} from "../../../interfaces/ISginUpSignInForm";
import { Stack, Typography } from "@mui/material";

export default function SignUpFormActions({
  onClickSignUp,
  loading,
  error,
}: SignUpFormActionsProps) {
  return (
    <Stack spacing={2} display="inline-flex" alignItems="center" width="100%">
      {error && (
        <Typography fontSize={14} color="error" variant="body1" align="center">
          {error}
        </Typography>
      )}
      <LoadingButton variant="contained" onClick={onClickSignUp} loading={loading}>
        Utwórz konto
      </LoadingButton>
    </Stack>
  );
}

export function SignInFormActions({ onClickSignIn, error, loading }: SignInFormActionsProps) {
  return (
    <Stack spacing={2} display="inline-flex" alignItems="center" width="100%">
      {error && (
        <Typography color="error" variant="body1">
          {error}
        </Typography>
      )}
      <LoadingButton variant="contained" onClick={onClickSignIn} loading={loading}>
        Zaloguj
      </LoadingButton>
    </Stack>
  );
}
